<template>
    <v-form
            ref="modifyDeviceForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="">
            <div class="d-flex align-center primary pl-3 pr-2">
                <div class="flex-grow-1 sub--text">
                    {{device.id ? 'Edit Device' : 'Create Device'}}
                </div>
                <div v-if="!device.id">
                    <v-btn
                            icon
                            color="white"
                            small
                            @click="$emit('dismiss')"
                    >
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="px-2 pb-1" style="overflow-x: hidden; overflow-y: hidden">
                <v-text-field
                        label="Device Description"
                        hide-details="auto"
                        v-model="device.description"
                        @change="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull]"
                />
                <v-autocomplete
                        label="Limit Device To"
                        placeholder="Dont Limit"
                        persistent-placeholder
                        hide-details="auto"
                        multiple
                        no-data-text="No Job Descriptions avaiable"
                        chips
                        deletable-chips
                        small-chips
                        v-model="device.limitDeviceTo"
                        :items="$store.getters.jobDescriptionNames"
                        @input="changesMade = true"
                        clearable
                        @click.clear="changesMade = true"
                />
                <v-switch
                        @change="changesMade = true"
                        hide-details="auto"
                        label="Intake Device"
                        v-model="intakeDeviceModel"
                        class="pt-2 mt-0"
                ></v-switch>
                <template v-if="editDevice && editDevice.id">
                    <div class="d-flex align-center pa-2">
                        <div class="text-body-2 flex-equal flex-grow-1">
                            Device ID:
                        </div>
                        <div class="text-body-1 flex-equal flex-grow-1">
                            <b>{{device.devID}}</b>
                        </div>
                    </div>
                    <div class="d-flex align-center pa-2">
                        <div class="text-body-2 flex-equal flex-grow-1">
                            Created:
                        </div>
                        <div class="text-body-1 flex-equal flex-grow-1">
                            <b>{{editDevice.createdDisplay}}</b>
                        </div>
                    </div>
                    <div class="d-flex align-center pa-2">
                        <div class="text-body-2 flex-equal flex-grow-1">
                            Last Sync Date:
                        </div>
                        <div class="text-body-1 flex-equal flex-grow-1">
                            <b>{{editDevice.lastSyncDisplay}}</b>
                        </div>
                    </div>
                </template>
            </div>
            <div class="text-right pr-2 pt-2 pb-2">
                <v-btn
                        @click="validateSave()"
                        fab
                        small
                        color="secondary"
                        :loading="loading"
                        :disabled="!changesMade || loading"
                >
                    <v-icon v-if="!loading">mdi-content-save</v-icon>
                </v-btn>
            </div>
        </div>
    </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {validationRules} from "../../../core/codeFunctions";

export default {
    components: {},
    props: {
        editDevice: Object
    },
    data() {
        return {
            device: null,
            loading: false,
            validationRules: validationRules,
            changesMade: false
        }
    },
    watch: {
        editDevice: {
            deep: true,
            immediate: true,
            handler(val) {
                this.changesMade = false
                this.device = JSON.parse(JSON.stringify(val))
            }
        },
    },
    methods: {
        validateSave() {
            if (!this.$refs.modifyDeviceForm.validate())
                return false

            this.$emit('save', {device: this.device, ref: this})
        }
    },
    computed: {
        ...mapGetters(['emp', 'farms']),
        intakeDeviceModel: {
            get() {
                return !!this.device.intakeDevice
            },
            set(val) {
                this.device.intakeDevice = val ? 1 : 0
            }
        },
    },
}
</script>

<style scoped>

</style>